<div class="access-request">
  <header>
    <div class="logo" [routerLink]="['./']">
      <img src="assets/img/accesshublogo.png" alt="accesshublogo">
    </div>
  </header>

  <div class="content">
    <div class="info-block">
      <div class="header">
        <div class="image">
          <img src="assets/img/accesshublogo.png" alt="accesshublogo">
        </div>
        <div class="title">User Access Request</div>
        <div class="subtitle">Request submitted successfully</div>
      </div>
      <div class="request-form">
        <div class="sign-in PL20">
          <div class="form-container MB0">
            <p class="paragraph">Thank you for submitting your user access request.</p>
            <p class="paragraph">You will hear from us soon.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer">
    <span class="copyright">Copyright © 2021 AbbVie Inc. North Chicago, Illinois, U.S.A.</span>
    <div>
      <a href="mailto:AccessHub@abbvie.com"><i></i>Questions, Comments or Feedback?</a>
    </div>
  </div>
</div>
